import React from "react";
import { toast } from "react-toastify";
import { useCart } from "../../../../contexts/CartContext";
import { useProductNavigation } from "../../../../shared/hooks/useProductNavigation";
import { CART_CONSTANTS } from "../../../../shared/components/FuncationsCartAndWishlist/Dto/AddToCardtUtilityDto";
import "./styles/CartItems.css";

const CartItems: React.FC = () => {
  const { 
    cartItems, 
    removeFromCart, 
    updateQuantity 
  } = useCart();

  const navigateToProduct = useProductNavigation();
  if (cartItems.length === 0) {
    return (
      <div className="cart-container">
        <div className="empty-cart">
          <h3>Your cart is empty</h3>
          <p>Looks like you haven't added anything to your cart yet.</p>
        </div>
      </div>
    );
  }

  const totalItems = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <div className="cart-container">
      <div className="cart-table">
        <div className="cart-header">
          <span>Product</span>
          <span>Quantity</span>
          <span>Total</span>
        </div>

        {cartItems.map((item) => {
          return (
            <div key={`${item.productId}-${item.variantSku || 'default'}`} className="cart-row">
              <div className="cart-item">
                <div className="cart-img-container">
                  <img
                    src={item.imageUrl}
                    alt={item.name || 'Product'}
                    className="cart-img"
                    style={{ cursor: 'pointer' }}
                    onClick={() => item.slug && navigateToProduct(item.slug)}
                  />
                  <button 
                    className="remove-btn" 
                    onClick={() => removeFromCart(item.productId, item.variantSku, item.variantId)}
                    aria-label="Remove item"
                  >
                    ✕
                  </button>
                </div>
                <div className="cart-info">
                  <p 
                    className="cart-name"
                    style={{ cursor: 'pointer' }}
                    onClick={() => item.slug && navigateToProduct(item.slug)}
                  >
                    {item.name || 'Unnamed Product'}
                  </p>

                  <div className="cart-variant-info">
                    {item.variantSku && (
                      <p className="cart-sku">SKU: {item.variantSku}</p>
                    )}
                    {item.variantTitle && (
                      <p className="cart-variant">Variant: {item.variantTitle}</p>
                    )}
                    {item.variantId && item.variantId !== item.variantSku && (
                      <p className="cart-variant">ID: {item.variantId}</p>
                    )}
                  </div>
                  <div className="quantity-controls mobile-only">
                    <div className="cart-quantity-selector">
                      <button 
                        className="quantity-btn-minus"
                        onClick={() => {
                          if (item.quantity > 1) {
                            updateQuantity(item.productId, item.quantity - 1, item.variantSku, item.variantId);
                          }
                        }}
                        disabled={item.quantity <= 1}
                        aria-label="Decrease quantity"
                      >
                        −
                      </button>
                      <span className="quantity-display">{item.quantity}</span>
                      <button 
                        className="quantity-btn-plus"
                        onClick={() => {
                          if (totalItems >= CART_CONSTANTS.MAX_ITEMS) {
                            toast.error('Maximum cart items reached. You cannot add more items to your cart.', {
                              position: 'bottom-right',
                              autoClose: 3000,
                            });
                            return;
                          }
                          if (item.quantity < CART_CONSTANTS.MAX_QUANTITY) {
                            updateQuantity(item.productId, item.quantity + 1, item.variantSku, item.variantId);
                          }
                        }}
                        disabled={item.quantity >= CART_CONSTANTS.MAX_QUANTITY || totalItems >= CART_CONSTANTS.MAX_ITEMS}
                        aria-label="Increase quantity"
                      >
                        +
                      </button>
                    </div>
                
                  </div>
                
                  <p className="cart-pack">
                    ₹{Math.round((item as any).priceWithGST || item.price || 0)} each
                  </p>
                </div>
              </div>              
              <div className="quantity-controls">
                <div className="cart-quantity-selector">
                  <button 
                    className="quantity-btn-minus"
                    onClick={() => {
                      if (item.quantity > 1) {
                        updateQuantity(item.productId, item.quantity - 1, item.variantSku, item.variantId);
                      }
                    }}
                    disabled={item.quantity <= 1}
                    aria-label="Decrease quantity"
                  >
                    −
                  </button>
                  <span className="quantity-display">{item.quantity}</span>
                  <button 
                    className="quantity-btn-plus"
                    onClick={() => {
                      if (totalItems >= CART_CONSTANTS.MAX_ITEMS) {
                        toast.error('Maximum cart items reached. You cannot add more items to your cart.', {
                          position: 'bottom-right',
                          autoClose: 3000,
                        });
                        return;
                      }
                      if (item.quantity < CART_CONSTANTS.MAX_QUANTITY) {
                        updateQuantity(item.productId, item.quantity + 1, item.variantSku, item.variantId);
                      }
                    }}
                    disabled={item.quantity >= CART_CONSTANTS.MAX_QUANTITY || totalItems >= CART_CONSTANTS.MAX_ITEMS}
                    aria-label="Increase quantity"
                  >
                    +
                  </button>
                </div>
              </div>
              
              <p className="cart-total">
                ₹{Math.round((((item as any).priceWithGST ?? item.price ?? 0) * item.quantity))}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CartItems;
